export default "__VITE_ASSET__BrejJW3x__"